var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.716 0-.972.975 3.122 3.154h-2.81c-2.924 0-5.386 1.295-7.085 3.305-1.698 2.01-2.665 4.72-2.72 7.602v.19h1.377v-.157c.048-2.596.919-5.002 2.386-6.735C8.487 6.6 10.53 5.516 13.055 5.516h2.811l-3.122 3.153.973.976L18.5 4.822 13.716 0ZM.5 4.129v11.79C.5 17.063 1.43 18 2.564 18h13.76c1.133 0 2.063-.937 2.063-2.08v-4.856h-1.376v4.855c0 .39-.3.694-.688.694H2.563a.682.682 0 0 1-.687-.694V4.13H.5Z",
  fill: "#DC632A"
})));
export default SvgShare;